import { outdoor_registry } from "./outdoor_registry";
import { random, round2, formatDateTime } from "../helpers/helpers";

export const generate_outdoor_latest_data_demo = ({ meter_id }) => {
    const sensor = outdoor_registry.find(s => s.meter_id === Number(meter_id));
    if (!sensor) return null;

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();

    const todayDate = `${day}-${month}-${year}`;

    return {
        sensor_name: sensor.meter_name,
        location: sensor.meter_name,
        meter_id: sensor.meter_id,

        status: "Online",
        last_seen: formatDateTime(now),

        aqi: Math.round(random(50, 100)),
        temperature: round2(random(24, 31)),
        humidity: round2(random(40, 65)),

        pm10: round2(random(30, 120)),
        pm2: round2(random(20, 90)),

        co: round2(random(600, 1800)),
        co_monoxide: 0,
        tvoc: round2(random(800, 30000)),
        smoke: round2(random(20, 8000)),
        formaldehyde: round2(random(10, 40)),

        no2: round2(random(10, 60)),   // Nitrogen Dioxide
        o3: round2(random(15, 70)),    // Ozone
        so2: round2(random(5, 40)),    // Sulfur Dioxide

        // Daily (filled – no N/A)
        daily_avg_temp: round2(random(25, 30)).toFixed(2),
        daily_max_temp: round2(random(30, 33)).toFixed(2),
        daily_max_temp_time: "14:30",
        daily_min_temp: round2(random(23, 25)).toFixed(2),
        daily_min_temp_time: "06:10",

        // Monthly (dynamic, no future)
        monthly_avg_temp: round2(random(26, 29)).toFixed(2),
        monthly_max_temp: round2(random(30, 34)).toFixed(2),
        monthly_max_temp_date: todayDate,
        monthly_min_temp: round2(random(22, 24)).toFixed(2),
        monthly_min_temp_date: todayDate,

        monthly_avg_pm10: round2(random(40, 90)).toFixed(2),
        monthly_avg_pm2: round2(random(30, 70)).toFixed(2),
        monthly_avg_co: round2(random(800, 1200)).toFixed(2),
        monthly_avg_humidity: round2(random(45, 60)).toFixed(2),
        monthly_avg_tvoc: round2(random(2000, 6000)).toFixed(2),

        is_temperature: true,
        is_humidity: true,
        is_pm10: true,
        is_pm2: true,
        is_co: true,
        is_co_monoxide: true,
        is_tvoc: true,
        is_smoke: true,
        is_formaldehyde: true,
        is_no2: true,
        is_o3: true,
        is_so2: true,
    };
};